(function () {
  var sectionSelector = '.pm-home-section';
  var revealSelector = '.pm-kicker, .pm-display, .pm-copy, .pm-button, .pm-card, .pm-recipe-card, .pm-ingredient-card, .pm-hero__brand-row, .pm-hero__visual, details';
  var parallaxSelector = '.pm-first-bowl, .pm-next-bowl';
  var curatedGallerySelector = '[data-pm-curated-mobile-gallery]';
  var curatedGalleryDotSelector = '[data-pm-curated-gallery-dot]';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var sections = new Map();
  var parallaxSections = new Map();
  var curatedGalleries = new Map();
  var motionObserver = null;
  var parallaxObserver = null;
  var parallaxTicking = false;

  function isReduced() {
    return reduceMotion.matches;
  }

  function disableDecorativeVideos(scope) {
    if (!isReduced()) return;

    scope.querySelectorAll('video[autoplay], video[loop]').forEach(function (video) {
      video.pause();
      video.removeAttribute('autoplay');
      video.removeAttribute('loop');
    });
  }

  function prepareSection(section) {
    if (sections.has(section)) return;

    var revealItems = Array.prototype.slice.call(section.querySelectorAll(revealSelector));
    revealItems.forEach(function (item, index) {
      item.style.setProperty('--pm-stagger-index', index);
    });

    section.classList.add('pm-motion-ready');
    sections.set(section, { revealItems: revealItems });

    if (motionObserver && !isReduced()) {
      motionObserver.observe(section);
    } else {
      section.classList.add('pm-motion-visible');
    }
  }

  function prepareParallax(section) {
    if (parallaxSections.has(section)) return;

    var layer = section.querySelector('.pm-first-bowl__photo, .pm-next-bowl__photo');
    if (!layer) return;

    layer.style.setProperty('--pm-parallax-y', '0px');
    parallaxSections.set(section, { layer: layer, active: false });

    if (parallaxObserver && !isReduced()) {
      parallaxObserver.observe(section);
    } else if (!('IntersectionObserver' in window) && !isReduced()) {
      parallaxSections.get(section).active = true;
    } else if (isReduced()) {
      layer.style.setProperty('--pm-parallax-y', '0px');
    }
  }

  function updateParallax() {
    parallaxTicking = false;

    if (isReduced()) {
      parallaxSections.forEach(function (controller) {
        controller.layer.style.setProperty('--pm-parallax-y', '0px');
      });
      return;
    }

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    parallaxSections.forEach(function (controller, section) {
      if (!controller.active) return;

      var rect = section.getBoundingClientRect();
      var progress = (rect.top + rect.height / 2 - viewportHeight / 2) / Math.max(viewportHeight, rect.height);
      var offset = Math.max(-42, Math.min(42, progress * -54));

      controller.layer.style.setProperty('--pm-parallax-y', offset.toFixed(2) + 'px');
    });
  }

  function requestParallaxUpdate() {
    if (parallaxTicking) return;

    parallaxTicking = true;
    window.requestAnimationFrame(updateParallax);
  }

  function getCuratedGallerySlides(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('[id^="Slide-PmCuratedGallery-"]'));
  }

  function setCuratedGalleryPage(gallery, page) {
    var controller = curatedGalleries.get(gallery);
    if (!controller) return;

    controller.dots.forEach(function (dot) {
      var isActive = Number(dot.getAttribute('data-slide-index')) === page;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function prepareCuratedGallery(gallery) {
    if (curatedGalleries.has(gallery)) return;

    var slider = gallery.querySelector('[id^="Slider-PmCuratedGallery-"]');
    var dots = Array.prototype.slice.call(gallery.querySelectorAll(curatedGalleryDotSelector));
    if (!slider || !dots.length) return;

    var onSlideChanged = function (event) {
      var currentPage = event.detail && event.detail.currentPage ? event.detail.currentPage : 1;
      setCuratedGalleryPage(gallery, currentPage);
    };

    var dotHandlers = dots.map(function (dot) {
      var handler = function (event) {
        event.preventDefault();

        var targetIndex = Number(dot.getAttribute('data-slide-index')) || 1;
        var slides = getCuratedGallerySlides(gallery);
        var targetSlide = slides[targetIndex - 1];
        var firstSlide = slides[0];

        if (!targetSlide) return;

        slider.scrollTo({
          left: targetSlide.offsetLeft - (firstSlide ? firstSlide.offsetLeft : 0),
        });
        setCuratedGalleryPage(gallery, targetIndex);
      };

      dot.addEventListener('click', handler);
      return { dot: dot, handler: handler };
    });

    gallery.addEventListener('slideChanged', onSlideChanged);
    curatedGalleries.set(gallery, {
      dots: dots,
      dotHandlers: dotHandlers,
      onSlideChanged: onSlideChanged,
      slider: slider,
    });
    setCuratedGalleryPage(gallery, 1);
  }

  function cleanupCuratedGallery(gallery) {
    var controller = curatedGalleries.get(gallery);
    if (!controller) return;

    gallery.removeEventListener('slideChanged', controller.onSlideChanged);
    controller.dotHandlers.forEach(function (entry) {
      entry.dot.removeEventListener('click', entry.handler);
    });
    curatedGalleries.delete(gallery);
  }

  function initialize(scope) {
    var base = scope || document;

    disableDecorativeVideos(base);

    Array.prototype.slice.call(base.querySelectorAll(sectionSelector)).forEach(prepareSection);
    if (base.matches && base.matches(sectionSelector)) {
      prepareSection(base);
    }

    Array.prototype.slice.call(base.querySelectorAll(parallaxSelector)).forEach(prepareParallax);
    if (base.matches && base.matches(parallaxSelector)) {
      prepareParallax(base);
    }

    Array.prototype.slice.call(base.querySelectorAll(curatedGallerySelector)).forEach(prepareCuratedGallery);
    if (base.matches && base.matches(curatedGallerySelector)) {
      prepareCuratedGallery(base);
    }

    requestParallaxUpdate();
  }

  function cleanup(scope) {
    var targets = Array.prototype.slice.call(scope.querySelectorAll(sectionSelector));

    if (scope.matches && scope.matches(sectionSelector)) {
      targets.push(scope);
    }

    targets.forEach(function (section) {
      if (motionObserver) motionObserver.unobserve(section);
      sections.delete(section);
      section.classList.remove('pm-motion-ready', 'pm-motion-visible');
    });

    Array.prototype.slice.call(scope.querySelectorAll(parallaxSelector)).forEach(function (section) {
      var controller = parallaxSections.get(section);
      if (parallaxObserver) parallaxObserver.unobserve(section);
      if (controller) controller.layer.style.removeProperty('--pm-parallax-y');
      parallaxSections.delete(section);
    });

    if (scope.matches && scope.matches(parallaxSelector)) {
      var scopeController = parallaxSections.get(scope);
      if (parallaxObserver) parallaxObserver.unobserve(scope);
      if (scopeController) scopeController.layer.style.removeProperty('--pm-parallax-y');
      parallaxSections.delete(scope);
    }

    Array.prototype.slice.call(scope.querySelectorAll(curatedGallerySelector)).forEach(cleanupCuratedGallery);
    if (scope.matches && scope.matches(curatedGallerySelector)) {
      cleanupCuratedGallery(scope);
    }
  }

  function setupObservers() {
    if (!('IntersectionObserver' in window) || isReduced()) return;

    motionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pm-motion-visible');
          motionObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

    parallaxObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var controller = parallaxSections.get(entry.target);
        if (!controller) return;

        controller.active = entry.isIntersecting;
      });

      requestParallaxUpdate();
    }, { rootMargin: '20% 0px 20% 0px', threshold: 0 });
  }

  function handleMotionPreferenceChange() {
    if (isReduced()) {
      sections.forEach(function (_controller, section) {
        section.classList.add('pm-motion-visible');
      });
      parallaxSections.forEach(function (controller) {
        controller.active = false;
        controller.layer.style.setProperty('--pm-parallax-y', '0px');
      });
      disableDecorativeVideos(document);
      return;
    }

    if (!motionObserver && !parallaxObserver) setupObservers();
    initialize(document);
    requestParallaxUpdate();
  }

  function boot() {
    setupObservers();
    initialize(document);
    handleMotionPreferenceChange();

    document.addEventListener('shopify:section:load', function (event) {
      initialize(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      cleanup(event.target);
    });

    document.addEventListener('shopify:section:reorder', function () {
      initialize(document);
    });

    document.addEventListener('shopify:section:select', function (event) {
      initialize(event.target);
      Array.prototype.slice.call(event.target.querySelectorAll(sectionSelector)).forEach(function (section) {
        section.classList.add('pm-motion-visible');
      });
    });

    window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
    window.addEventListener('resize', requestParallaxUpdate);

    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', handleMotionPreferenceChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
